<template>
	<div>
		<!-- item-->
		<div class="dropdown-item noti-title">
			<h5 class="m-0">
				<span class="float-right">
					<a href="#" @click="markAsReadAll" :disabled="markAllLock" class="text-dark" v-if="notifications.length">
						<small>Mark as read all</small>
					</a>
				</span>
				Notifications <span class="loader small_loader" v-if="loading"></span>
			</h5>
		</div>
		<perfect-scrollbar class="scroll-area">
			<!-- item-->
			<a href="javascript:void(0);" class="dropdown-item notify-item" v-for="notification in notifications" :key="notification.docID" @click="goToNotifications()">
				<div class="row">
					<div class="col-md-8">
						<div class="notify-icon">
							<span class="badge badge-pill" :class="getStatusClass(notification.type)">{{notification.type.toUpperCase()}}</span>
						</div>
						<p class="notify-details">
							{{notification.from.name}}<br/>
							<small class="text-muted mb-0 user-msg" v-if="notification.message.length <= 36">
								{{notification.message}}
							</small>
							<small class="text-muted mb-0 user-msg" v-else>
								{{notification.message.substring(0,33) + '...'}}
							</small>
						</p>
					</div>
					<div class="col-md-4 text-right">
						<small>{{notification.createdAt | fromNow}}</small>
					</div>
				</div>
			</a>
		</perfect-scrollbar>
		<!-- All-->
		<router-link tag="a" :to="{ name: 'notificationsPage' }" class="dropdown-item text-center text-primary notify-item notify-all">
			View all
			<i class="fa fa-arrow-right"></i>
		</router-link>
	</div>
</template>

<script type="text/babel">
	import {functions} from "@/firebase/init";
	import {PerfectScrollbar} from 'vue2-perfect-scrollbar';
	import notificationMixin from "../../mixins/notificationMixin";

	export default {
		mixins: [notificationMixin],
		data() {
			return {
				markAllLock: false,
				loading: false
			}
		},
		components: {
			PerfectScrollbar,
		},
		computed: {
			userToken() {
				return this.$store.getters.getUserToken;
			},
			user() {
				return this.$store.getters.user;
			},
			notifications() {
				return this.$store.getters['notification/getLastFourNotifications'];
			},
			UID(){
				return this.$store.getters.getUID;
			}
		},
		methods: {
			goToNotifications() {
				this.$router.push('/notifications');
			},
			markAsReadAll(){
				this.markAllLock = true;
				this.loading = true;
				const markAsReadAllNotification = functions.httpsCallable(
					"markAsReadAllNotification"
				);
				markAsReadAllNotification({UID: this.UID})
						.then(() => {
							this.$store.dispatch('notification/resetNotifications')
						})
						.catch(err => {
							console.log(err.message);
						})
						.finally(() =>{
							this.loading = false;
							this.markAllLock = false;
						})
			}
		}
	}
</script>

<style src="vue2-perfect-scrollbar/dist/vue2-perfect-scrollbar.css"/>
<style scoped>
	.small_loader{
		width: 15px;
		height: 15px;
		display: inline-grid;
	}
	.slimScrollDiv {
		height: auto !important;
	}
	.scroll-area {
		position: relative;
		width: 350px;
		max-height: 230px;
		overflow: hidden;
	}
</style>
<style>

	.notification-list .noti-icon-badge {
		display: inline-block;
		position: absolute;
		top: 10px;
		right: 10px;
	}

	.notification-list .fa-bell {
		font-size: 21px;
		vertical-align: middle;
		color: #007bff;
	}

	.notification-list .badge {
		display: inline-block;
		padding: .25em .4em;
		font-size: 75%;
		font-weight: 500;
		line-height: 1;
		text-align: center;
		white-space: nowrap;
		vertical-align: baseline;
		border-radius: .25rem;
		-webkit-transition: color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out, -webkit-box-shadow .15s ease-in-out;
		transition: color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out, -webkit-box-shadow .15s ease-in-out;
		transition: color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out;
		transition: color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out, -webkit-box-shadow .15s ease-in-out;
	}

	.notification-list .noti-title {
		background-color: #fff;
		padding: 15px 20px;
	}

	.navbar .navbar-nav .nav-link {
		padding: 0.5rem 0rem;
	}

	.notification-list .h5, .notification-list h5 {
		font-size: .812rem;
	}

	.notification-list .dropdown-item {
		display: block;
		width: 100%;
		padding: .375rem 1.2rem;
		clear: both;
		font-weight: 400;
		color: #72747b;
		text-align: inherit;
		white-space: nowrap;
		background-color: transparent;
		border: 0;
	}

	.notification-list .dropdown-item.active,
	.notification-list .dropdown-item:active,
	.notification-list .dropdown-item:hover {
		color: #323a46;
		text-decoration: none;
		background-color: #f7f7f7 !important;
	}

	.notify-all {
		font-size: .812rem;
	}



	.noti-scroll {
		max-height: 230px;
	}

	.notification-list .notify-item {
		padding: 12px 20px;
	}

	.notification-list .notify-item .notify-details {
		margin-bottom: 5px;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
		color: #343a40;
		font-size: .8125rem;
	}

	.notification-list .notify-item .user-msg {
		white-space: normal;
		line-height: 16px;
		display: block;
		/*margin-left: 45px;*/
	}

	.notification-list .small, .notification-list small {
		font-size: .75rem;
		font-weight: 400;
	}
	.notification-list .notify-item .notify-icon {
		float: left;
		height: 36px;
		width: 65px;
		text-align: left;
		margin-right: 10px;
		border-radius: 50%;
		color: #fff;
	}
</style>
